import { tracked } from '@glimmer/tracking';

import type { APIData, GeneralComponentClass } from 'webapp-types';

import InfolayerTypeBoardSnapshotComponent from 'webapp/components/infolayer/type-board-snapshot';

import type {
	ConstructorData as BaseConstructorData,
	onCloseFn,
} from 'webapp/models-custom/infolayer-item/base';
import InfolayerItemBase from 'webapp/models-custom/infolayer-item/base';
import InfolayerItemSnapshotBase from 'webapp/models-custom/infolayer-item/snapshot-base';

export interface BoardLikeType {
	name: string;
	specificSourceTypesKeys: string[];
}

export interface ConstructorData extends BaseConstructorData {
	board: BoardLikeType;
}

export default class InfolayerItemBoardSnapshot extends InfolayerItemSnapshotBase {
	componentClass: GeneralComponentClass = InfolayerTypeBoardSnapshotComponent;

	@tracked snapshotData: APIData.Snapshot.Response | null = null;
	@tracked board: BoardLikeType;

	constructor(data: ConstructorData, onClose: onCloseFn) {
		super(data, onClose);

		this.board = data.board;
	}

	override setDone(snapshotData: APIData.Snapshot.Response) {
		this.snapshotData = snapshotData;
		super.setDone(snapshotData);
	}

	protected override isSameType(item: InfolayerItemBase) {
		return super.isSameType(item) && item instanceof InfolayerItemBoardSnapshot;
	}
}
